<!-- Hints tour -->
<div class="backdrop"></div>

<qai-alert class="showcase" kind="hint" [title]="('call.HINTS_AND_SUGGESTIONS_TITLE' | transloco)">
  <div class="text">
    {{'call.TIPS_GUIDANCE_MESSAGE' | transloco}}
  </div>
  <button
    qai-button
    kind="primary"
    size="xsmall"
    (click)="handleContinueTourClick()"
  >
  {{'call.START_CALL'| transloco}}
  </button>
</qai-alert>
